import { render, staticRenderFns } from "./AssetPublishStatus.vue?vue&type=template&id=134da922"
import script from "./AssetPublishStatus.vue?vue&type=script&lang=js"
export * from "./AssetPublishStatus.vue?vue&type=script&lang=js"
import style0 from "./AssetPublishStatus.vue?vue&type=style&index=0&id=134da922&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports